import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AboutPage from "../Components/About/AboutPage";
import VisionAndMissionPage from "../Components/Vision/VisionAndMissionPage";
import BrandPage from "../Components/Brand/BrandPage";
import GlovisPage from "../Components/Brand/GlovisPage";
import DizzeePage from "../Components/Brand/DizzeePage";
import CarefinPage from "../Components/Brand/CarefinPage";
import WildArmyPage from "../Components/Brand/WildArmyPage";
import HomePage from "../Components/Home/HomePage";
import ContactPage from "../Components/Contact/ContactPage";
import NotFoundPage from "../Components/Home/NotFoundPage";

// -- ScrollToTop component to handle scrolling to top on route changes -- //
const ScrollToTop = ({ children }) => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ScrollToTop>
          <HomePage />
        </ScrollToTop>
      } />
      <Route path="/about" element={
        <ScrollToTop>
          <AboutPage />
        </ScrollToTop>
      } />
      <Route path="/vision-and-mission" element={
        <ScrollToTop>
          <VisionAndMissionPage />
        </ScrollToTop>
      } />
      <Route path="/brand" element={
        <ScrollToTop>
          <BrandPage />
        </ScrollToTop>
      } />
      <Route path="/brand/glovis" element={
        <ScrollToTop>
          <GlovisPage />
        </ScrollToTop>
      } />
      <Route path="/brand/dizzee" element={
        <ScrollToTop>
          <DizzeePage />
        </ScrollToTop>
      } />
      <Route path="/brand/carefin" element={
        <ScrollToTop>
          <CarefinPage />
        </ScrollToTop>
      } />
      <Route path="/brand/wild-army" element={
        <ScrollToTop>
          <WildArmyPage />
        </ScrollToTop>
      } />
      <Route path="/contact" element={
        <ScrollToTop>
          <ContactPage />
        </ScrollToTop>
      } />
      
      {/* 404 Route - Must be last */}
      <Route path="*" element={
        <ScrollToTop>
          <NotFoundPage />
        </ScrollToTop>
      } />

    </Routes>
  );
};

export default AppRoutes;
